// 主题模块API接口

import utils from "../../../utils";
import { BaseApi } from "../../../utils/request";
import { Theme } from "../types";

// 主题API
export class ThemeApi extends BaseApi {
  // 获取主题配置
  async getTheme(themeId: string): Promise<Theme> {
    const device = utils.getDeviceType();

    // 构建主题URL
    let url = `/static/theme/${themeId}`;
    url += `?device=${device}`;
    const response = await this.get<Theme, true>(
      url,
      {},
      {
        cache: true,
        cacheTime: 60 * 60 * 1000,
        alert: false,
      }
    );
    return response.data.model;
  }

  // 获取主题列表
  async getThemeList(): Promise<Theme[]> {
    const response = await this.get<Theme[], true>(
      "/api/theme/list",
      {},
      {
        cache: true,
        cacheTime: 30 * 60 * 1000, // 30分钟缓存
        alert: false,
      }
    );
    return response.data.model;
  }
}

// 创建API实例
export const themeApi = new ThemeApi();
